module.exports = __webpack_public_path__ + "static/floorplan4-868f254e445c5cd3d3d4f489c5e9a0e2.png";